import { render } from "./Asr.vue?vue&type=template&id=3a6bc88c&scoped=true"
import script from "./Asr.vue?vue&type=script&lang=js"
export * from "./Asr.vue?vue&type=script&lang=js"

import "./Asr.vue?vue&type=style&index=0&id=3a6bc88c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6bc88c"]])

export default __exports__